import {useEnabledModelsOfProject} from '@/biz/enabledModel.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, subTypeCode} = map.data
    const models = useEnabledModelsOfProject({mapTypeCode, subTypeCode})

    const isDesign = type => {
        const {classes} = map.BizNode[type]

        return (
            classes.includes('design') &&
            ! classes.includes('arch') &&
            ! classes.includes('module')
        )
    }

    return [...models]
        .filter(isDesign)
        .map(t => [t, map.BizNode[t].typeName(map)])
}
